module.exports = __webpack_public_path__ + "img/logo-en_us.bfe627bf.svg";